import { EyeInvisibleOutlined, EyeOutlined } from '@ant-design/icons';
import { Form, Input, Modal, Typography } from 'antd';
import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import OtpInput from 'react18-input-otp';
import { useSelector } from 'react-redux';
import { UserRespose } from '../../../../redux/Reducer/userReducer';
import './index.css';
import OTPInputModalFooter from './OTPInputModalFooter';

interface IModalComponentProps {
  isOpen: boolean;
  onOtpSubmit: (otp: string) => void;
  onCancel: () => void;
  okText: string;
  numInputs?: number;
  title: string;
  onResend: () => void;
  mobileNumber?: string;
  isLinkAccount?: boolean;
  disabledOtpSubmit?: boolean;
}

const OTPInputComponent: React.FC<IModalComponentProps> = ({
  isOpen,
  okText,
  onOtpSubmit,
  onCancel,
  children,
  title,
  onResend,
  mobileNumber,
  isLinkAccount = false,
  disabledOtpSubmit = false,
}) => {
  const { t } = useTranslation();
  const otpResendDuration = 30;
  const [OTP, setOTP] = useState('');
  const [counter, setCounter] = useState(otpResendDuration);
  const timer = useRef<any>();

  const user: UserRespose = useSelector((state: any) => state.user.user);

  useEffect(() => {
    if (!isOpen) {
      form.resetFields();
      setCounter(0);
    } else {
      setCounter(otpResendDuration);
    }
  }, [isOpen]);

  const changeInput = (otp: string) => {
    setOTP(otp);
  };

  useEffect(() => {
    if (counter <= 0) {
      clearTimeout(timer.current);
      return;
    }
    timer.current = setTimeout(() => setCounter(counter - 1), 1000);
  }, [counter]);

  const resendOTP = () => {
    setCounter(otpResendDuration);
    onResend();
  };

  const onOTPSubmit = () => {
    form.submit();
  };

  const formSubmit = (values: any) => {
    onOtpSubmit(values.otp);
  };

  const changeInput1 = (e: any) => {
    e.target.value = e.target.value.replace(/[^0-9]/gi, '');
    setOTP(e.target.value);
  };

  const customValidator = (_: any, value: string) => {
    if (!isLinkAccount && value && value.length !== 6)
      return Promise.reject(new Error(`Enter ${6} digit OTP`));
    return Promise.resolve();
  };

  const [form] = Form.useForm();
  return (
    <Modal
      title={title}
      className='footerRoot'
      open={isOpen}
      okText={okText}
      cancelButtonProps={{ hidden: true }}
      okButtonProps={{ id: 'submitButton' }}
      destroyOnClose={true}
      footer={[
        // tslint:disable-next-line: jsx-key
        <OTPInputModalFooter
          // tslint:disable-next-line: jsx-no-lambda
          onOtpModalFooterSubmit={onOTPSubmit}
          isResendActive={true}
          buttonLabel={okText}
          counter={counter}
          onResend={resendOTP}
          disabledOtpSubmit={disabledOtpSubmit}
        />,
      ]}
      onCancel={onCancel}
    >
      <Typography.Text className='typoOTP'>
        {t('OTP has been sent to')}{' '}
        <Typography.Text>
          {mobileNumber && mobileNumber.length !== 0
            ? mobileNumber
            : user.mobileNumber}
        </Typography.Text>
      </Typography.Text>
      <br />
      {children}

      <Form
        form={form}
        className='form otpForm'
        name='basic'
        onFinish={formSubmit}
        autoComplete='off'
        scrollToFirstError={true}
      >
        <Form.Item
          className='formItemMarginBotton'
          name={'otp'}
          rules={[
            {
              required: true,
              message: '* Required field',
            },
            {
              validator: customValidator,
            },
          ]}
        >
          {isLinkAccount ? (
            <Input.Password
              type='password'
              autoComplete='off'
              value={OTP}
              // tslint:disable-next-line: jsx-no-lambda
              iconRender={(visible) =>
                visible ? <EyeOutlined /> : <EyeInvisibleOutlined />
              }
              inputMode='tel'
              onChange={changeInput1}
              className={`formItemPinInput`}
              maxLength={6}
            />
          ) : (
            <OtpInput
              isInputSecure={true}
              value={OTP}
              onChange={changeInput}
              containerStyle={'containerClass'}
              inputStyle={'inputStyle'}
              numInputs={6}
            />
          )}
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default OTPInputComponent;
